import React, { useState, useEffect } from "react";
import "./style/OtpVerify.css";
import meetingPlusLogo from "../../assets/images/MinutesPlusVaultLogo1.svg";
import { useNavigate, Navigate, Link, useLocation } from "react-router-dom";
import LoginImage from "./LoginImage";
import { useSelector, useDispatch } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import {
  reSendOtp,
  updateIsSuccess,
  updateOtpProcessed,
  verifyOtp,
} from "../../redux/actions/authActions/authAction";
import * as constantMessages from "../../constants/constatntMessages";
import Timer from "../Common/Timer";
import { toast } from "react-toastify";
const isLogIn = false;

const OtpVerify = () => {
  document.body.classList.remove("landing-page");
  const location = useLocation();
  const { currentPath } = location.state || {}; // get the state from location

  const [errors, setErrors] = useState({});
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [formData, setFormData] = useState({
    input1: null,
    input2: null,
    input3: null,
    input4: null,
    input5: null,
    input6: null,
  });
  const authData = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Verify OTP: MinutesVault";
    const inputId = document.getElementById(parseInt(1));
    inputId.focus();
    if (isLogIn) {
      navigate("/dashboard");
    }
    if (!authData.email) {
      navigate("/login");
    }
    return () => {
      toast.dismiss(); // removes all toasts
    };
  }, []);

  const resendOtpAction = (e) => {
    if (authData.email) {
      dispatch(reSendOtp(authData.email));
      setIsResendOtp(false);
      setFormData({
        ...formData,
        input1: "",
        input2: "",
        input3: "",
        input4: "",
        input5: "",
        input6: "",
      });
    } else {
      errors.message = constantMessages.emailRequired;
      setErrors(errors);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors?.errors);
    if (Object.keys(newErrors.errors).length === 0) {
      // Form submission logic here
      const otp = newErrors.otpData;
      dispatch(verifyOtp({ email: authData.email, otp }));
    } else {
    }
  };

  const handleChange = (e) => {
    dispatch(updateOtpProcessed(false));
    const { value, name, id } = e.target;
    const digitsOnly = value.replace(/\D/g, ""); // extract only digits

    const updatedFormData = { ...formData };
    let currentIndex = parseInt(id);

    // Fill each digit into corresponding field
    for (
      let i = 0;
      i < digitsOnly.length && currentIndex <= 6;
      i++, currentIndex++
    ) {
      updatedFormData[`input${currentIndex}`] = digitsOnly[i];
      const inputField = document.getElementById(currentIndex);
      if (inputField) inputField.value = digitsOnly[i];
    }

    setFormData(updatedFormData);

    // Move focus to next empty field
    for (let i = parseInt(id) + digitsOnly.length; i <= 6; i++) {
      if (!updatedFormData[`input${i}`]) {
        const nextField = document.getElementById(i);
        if (nextField) {
          nextField.focus();
          break;
        }
      }
    }
  };

  
  const handleKeyDown = (e) => {
    const { id, name } = e.target;
    const fieldId = parseInt(id);

    const invalidKeys = ["e", "-", "+", ".", ","];

    if (invalidKeys.includes(e.key.toLowerCase())) {
      e.preventDefault();
      return;
    }

    if (e.key === "Backspace") {
      setFormData((prev) => ({
        ...prev,
        [name]: "",
      }));

      // Delay the focus movement to allow input to clear first
      setTimeout(() => {
        const currentInput = document.getElementById(fieldId);
        if (currentInput?.value === "") {
          const prevField = document.getElementById(fieldId - 1);
          if (prevField) {
            prevField.focus();
          }
        }
      }, 0);
    }
  };

  // PRATISHRUTI END CODE HERE

  const setResendOtp = (data) => {
    setIsResendOtp(true);
  };

  const otp = [];
  const validateForm = (data) => {
    dispatch(updateOtpProcessed(false));
    const errors = {};
    if (!authData.email) {
      errors.message = constantMessages.emailRequired;
    }
    if (!data.input1) {
      errors.message = "OTP is required";
    } else if (isNaN(data.input1)) {
      errors.message = "OTP must be a number";
    }

    otp.push(data.input1);

    if (!data.input2) {
      errors.message = "OTP is required";
    } else if (isNaN(data.input2)) {
      errors.message = "OTP must be a number";
    }
    otp.push(data.input2);
    if (!data.input3) {
      errors.message = "OTP is required";
    } else if (isNaN(data.input3)) {
      errors.message = "OTP must be a number";
    }
    otp.push(data.input3);
    if (!data.input4) {
      errors.message = "OTP is required";
    } else if (isNaN(data.input4)) {
      errors.message = "OTP must be a number";
    }
    otp.push(data.input4);
    if (!data.input5) {
      errors.message = "OTP is required";
    } else if (isNaN(data.input5)) {
      errors.message = "OTP must be a number";
    }
    otp.push(data.input5);

    if (!data.input6) {
      errors.message = "OTP is required";
    } else if (isNaN(data.input6)) {
      errors.message = "OTP must be a number";
    }
    otp.push(data.input6);
    if (otp.length !== 6) {
      errors.message = "OTP must be of 6 digits";
    }
    const otpData = otp.join("");

    return {
      errors,
      otpData,
    };
  };
  const otpFieldValidationCheck = (e) => {
    const errors = {};

    if (!e.target.value) {
      errors.message = "OTP is required";
    } else if (isNaN(e.target.value)) {
      errors.message = "OTP must be a number";
    }

    setErrors(errors);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    const digitsOnly = pastedData.replace(/\D/g, "");

    if (!digitsOnly) return;

    const updatedFormData = { ...formData };

    // Find the field where the paste occurred
    const startId = parseInt(e.target.id);
    let currentIndex = startId;

    for (
      let i = 0;
      i < digitsOnly.length && currentIndex <= 6;
      i++, currentIndex++
    ) {
      updatedFormData[`input${currentIndex}`] = digitsOnly[i];

      const inputField = document.getElementById(currentIndex);
      if (inputField) {
        inputField.value = digitsOnly[i];
      }
    }

    setFormData(updatedFormData);

    // Move focus to next empty field
    for (let i = startId + digitsOnly.length; i <= 6; i++) {
      if (!updatedFormData[`input${i}`]) {
        const nextField = document.getElementById(i);
        if (nextField) {
          nextField.focus();
          break;
        }
      }
    }
  };

  return (
    <section className="otp-varify">
      {authData.isOtpVerifiedSuccess && currentPath ? (
        <Navigate to={currentPath} />
      ) : authData.isOtpVerifiedSuccess ? (
        <Navigate to="/meeting-list" />
      ) : null}

      <div className="container-fluid">
        <div className="row login-row">
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 first-login-col">
            <div className="loginform-container otp-page abstract-bg">
              <div className="logo-container">
                <Link
                  to="/"
                  onClick={() => {
                    if (!authData.loading) {
                      dispatch(updateIsSuccess(false));
                    }
                  }}
                >
                  <img
                    className="login-logo"
                    // @ts-ignore
                    src={meetingPlusLogo}
                    alt="logo"
                  />
                </Link>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="text">
                  <h4>Welcome to MinutesVault</h4>
                  <p>
                    Please check your email for the OTP required to complete the
                    authentication process.
                  </p>
                </div>

                <div className="form-group res-991-otp">
                  <label className="mb-1">
                    Enter Your 6 Digit OTP <span className="imp-field">*</span>
                  </label>
                  <div className="pincode">
                    <div className="digit">
                      <input
                        type="number"
                        name="input1"
                        maxLength={1}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        onBlur={otpFieldValidationCheck}
                        value={formData.input1}
                        autoComplete="off"
                        autoFocus={true}
                        id={1}
                        onPaste={handlePaste} // <-- allow paste only here
                        onCopy={(e) => e.preventDefault()}
                      />
                    </div>

                    <div className="digit">
                      <input
                        type="number"
                        name="input2"
                        maxLength={1}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                        onBlur={otpFieldValidationCheck}
                        value={formData.input2}
                        autocomplete="off"
                        id={2}
                        onPaste={handlePaste}
                        onCopy={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="digit">
                      <input
                        type="number"
                        name="input3"
                        maxLength={1}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                        onBlur={otpFieldValidationCheck}
                        value={formData.input3}
                        autocomplete="off"
                        id={3}
                        onPaste={handlePaste}
                        onCopy={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="digit">
                      <input
                        type="number"
                        name="input4"
                        maxLength={1}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                        onBlur={otpFieldValidationCheck}
                        value={formData.input4}
                        autocomplete="off"
                        id={4}
                        onPaste={handlePaste}
                        onCopy={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="digit">
                      <input
                        type="number"
                        name="input5"
                        maxLength={1}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                        onBlur={otpFieldValidationCheck}
                        value={formData.input5}
                        autocomplete="off"
                        id={5}
                        onPaste={handlePaste}
                        onCopy={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="digit">
                      <input
                        type="number"
                        name="input6"
                        maxLength={1}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                        onBlur={otpFieldValidationCheck}
                        value={formData.input6}
                        autocomplete="off"
                        id={6}
                        onPaste={handlePaste}
                        onCopy={(e) => e.preventDefault()}
                      />
                    </div>
                  </div>
                  {errors.message && (
                    <span className="error-message">{errors.message}</span>
                  )}
                </div>

                {!authData.loading ? (
                  <button className="signin-btn1" type="submit">
                    {" "}
                    Verify OTP
                  </button>
                ) : (
                  <button disabled={true} className="signin-btn1" type="button">
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    Processing...
                  </button>
                )}

                <div className="back-resend back-arrow">
                  <Link to="/login">
                    <div className="back">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#0b77e8"
                        className="bi bi-arrow-left"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                        />
                      </svg>
                      <span
                        onClick={() => {
                          if (!authData.loading) {
                            dispatch(updateIsSuccess(false));
                          }
                        }}
                      >
                        Back to Sign In
                      </span>
                    </div>
                  </Link>
                  {authData.isTimerOn ? (
                    <span>
                      {constantMessages.otpCountDownMessage}
                      <Timer
                        setResendOtp={setResendOtp}
                        minutes={
                          authData.isOtpProcessed && !authData.isSuccess
                            ? process.env.REACT_APP_OTP_RESEND_TIME
                            : process.env.REACT_APP_CHECK_OTP_VALIDATION_TIME
                        }
                      />
                    </span>
                  ) : (
                    <div className="resend">
                      <Link to="" onClick={resendOtpAction}>
                        Resend OTP
                      </Link>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
          <LoginImage />
        </div>
      </div>
    </section>
  );
};

export default OtpVerify;
